import service from "./service"

const preCheckForm = async (key) => {
    return service(key)
}

export default preCheckForm
